import produce from 'immer';

const INITIAL_STATE = {    
  loading: false,
};

export default function esqueciminhasenha(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@forgot/FORGOT_IN_SUCCESS': {        
        draft.loading = false;
        break;
      }
      case '@forgot/FORGOT_IN_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@forgot/FORGOT_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@forgot/FORGOT_OUT': {        
        break;
      }
      default:
    }
  });
}
